import { render, staticRenderFns } from "./UiPermissions.vue?vue&type=template&id=44b95672"
import script from "./UiPermissions.vue?vue&type=script&lang=js"
export * from "./UiPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports